import { Workbook } from "exceljs";
import { config } from "../config/config-hazard";
import { excelLocation } from "../location/location-item";
import { tx } from "../common/excel-hazard";
import {
  buildGroupByPointIdMap,
  normalizePointId
} from "../common/point-id-index";

export const excelSheetHazard = (
  t: any,
  workbook: Workbook,
  sheetNum: number,
  locationsTable: any[],
  hazardResult: any[]
) => {
  const worksheet = workbook.getWorksheet(sheetNum);

  if (!worksheet) {
    return;
  }

  const dataItem = excelLocation(worksheet, t, locationsTable);

  if (!dataItem || dataItem.length === 0) {
    return;
  }

  if (!hazardResult || hazardResult.length === 0) {
    return;
  }

  const hazardByPointId = buildGroupByPointIdMap(
    hazardResult,
    (hazardItem: any) => hazardItem?.pointId
  );

  dataItem.forEach((item: any, i: number) => {
    const dataHazardFiltered = hazardByPointId.get(normalizePointId(item?.id));

    if (!dataHazardFiltered || dataHazardFiltered.length === 0) {
      return null;
    }

    dataHazardFiltered.forEach((e: any) => {
      hazardLayer(e, worksheet, i + 2, t);
      hazardDetail(e, worksheet, i + 2, t);
      hazardInstance(e, worksheet, i + 2, t);
      hazardHailAdditionalDetails(e, worksheet, i + 2, t);
    });
  });
};

const hazardLayer = (e: any, worksheet: any, rowNum: number, t: any) => {
  const c = config[e.layerId];
  const v = e.valueLabel;
  tx(c, v, worksheet, rowNum, t);
};

const hazardDetail = (
  analyzeItem: any,
  worksheet: any,
  rowNum: number,
  t: any
) => {
  if (typeof analyzeItem !== "object") {
    return;
  }

  if (!analyzeItem.details) {
    return;
  }

  const keysInDetails = Object.keys(analyzeItem.details);

  if (!keysInDetails || keysInDetails.length === 0) {
    const keysInConfig = Object.keys(config);
    if (!keysInConfig || keysInConfig.length === 0) {
      return;
    }

    const keysInFilter = keysInConfig.filter(
      (key) =>
        key !== analyzeItem.layerId &&
        key.includes(analyzeItem.layerId) &&
        !key.includes("intensity")
    );

    if (!keysInFilter || keysInFilter.length === 0) {
      return;
    }

    keysInFilter.forEach((key) => {
      const c = config[key];
      const v = t("legend.No_Data");
      tx(c, v, worksheet, rowNum, t);
    });

    return;
  }

  keysInDetails.forEach((key) => {
    const details = analyzeItem.details as any;
    if (details[key] === null) {
      return;
    }

    const c = config[analyzeItem.layerId + "." + key];
    const v = details[key];
    tx(c, v, worksheet, rowNum, t);
  });
};

const hazardInstance = (
  analyzeItem: any,
  worksheet: any,
  rowNum: number,
  t: any
) => {
  const c = config[analyzeItem.layerId + ".intensity"];
  const v = analyzeItem.intensity;
  tx(c, v, worksheet, rowNum, t);
};

const hazardHailAdditionalDetails = (
  analyzeItem: any,
  worksheet: any,
  rowNum: number,
  t: any
) => {
  if (typeof analyzeItem !== "object") {
    return;
  }

  const hailAdditionalDetails = analyzeItem.hailAdditionalDetails as any;

  if (!hailAdditionalDetails) {
    return;
  }

  if (typeof hailAdditionalDetails !== "object") {
    return;
  }

  const set31 = hailAdditionalDetails["HailHazard-31-year-historical-data-set"];
  const set64 = hailAdditionalDetails["HailHazard-64-year-historical-data-set"];

  if (set31) {
    Object.keys(set31).forEach((key) => {
      const c = config[analyzeItem.layerId + ".31-set." + key];
      const v = set31[key];
      tx(c, v, worksheet, rowNum, t);
    });
  }

  if (set64) {
    Object.keys(set64).forEach((key) => {
      const c = config[analyzeItem.layerId + ".64-set." + key];
      const v = set64[key];
      tx(c, v, worksheet, rowNum, t);
    });
  }
};

const hazardTornadoAdditionalDetails = (
  analyzeItem: any,
  worksheet: any,
  rowNum: number,
  t: any
) => {
  if (typeof analyzeItem !== "object") {
    return;
  }

  const tornadoAdditionalDetails = analyzeItem.additionalDetails as any;

  if (!tornadoAdditionalDetails) {
    return;
  }

  if (typeof tornadoAdditionalDetails !== "object") {
    return;
  }

  const c = config[analyzeItem.layerId + ".30-year trend"];
  const v = tornadoAdditionalDetails["30-year trend"];
  tx(c, v, worksheet, rowNum, t);
};
